import moment from "moment";

export function getEffectiveDate(polEDate, isPaperEnrollment, enrollmentReceivedDate, dateOfHire, isNewHire, newHireWaitingPeriod, benefitEligibilityDate) {
    let mPolicyEffectiveDate = moment(polEDate);
    let mEnrollmentReceivedDate = moment();
    let mDateOfHire = moment(dateOfHire);

    if (isPaperEnrollment) {
        mEnrollmentReceivedDate = moment(enrollmentReceivedDate);
    }

    let mBenefitEligibilityDate = mPolicyEffectiveDate;

    if (isNewHire && benefitEligibilityDate !== null) {
        mBenefitEligibilityDate = moment(benefitEligibilityDate);
    }

    if (isNewHire && benefitEligibilityDate === null) {
        mBenefitEligibilityDate = resolveNewHireWaitingPeriodDate(mDateOfHire, newHireWaitingPeriod);
    }

    let effectiveDate = moment.max(mPolicyEffectiveDate, mEnrollmentReceivedDate, mBenefitEligibilityDate);

    if (isNewHire && mEnrollmentReceivedDate.isAfter(mBenefitEligibilityDate) && mEnrollmentReceivedDate.isAfter(mPolicyEffectiveDate)) {
        effectiveDate = mEnrollmentReceivedDate.add(1, 'M').startOf('M');
    }

    return effectiveDate.toISOString();
}

export function resolveNewHireWaitingPeriodDate(mDateOfHire, newHireWaitingPeriod) {

    let nhwp = mDateOfHire;
    switch (newHireWaitingPeriod) {
        case "Date of hire":
            break
        case "First of the month following date of hire":
            nhwp.add(1, 'M').startOf('M')
            break
        case "Date of hire + 30 days":
            nhwp.add(30, 'd')
            break
        case "First of the month following date of hire + 30 days":
            nhwp.add(1, 'M').add(30, 'd').startOf('M')
            break
        case "Date of hire + 60 days":
            nhwp.add(60, 'd')
            break
        case "First of the month following date of hire + 60 days":
            nhwp.add(1, 'M').add(60, 'd').startOf('M')
            break
        default:
            break
    }

    return nhwp;
}


